<template>
  <section class="is-flex">
    <div v-if="isLoggedIn === false"
      class="has-text-white">
      <span class="mdi mdi-alert"></span>
      {{ $t('common.unlogged') }}
      <span class="mdi mdi-alert"></span>
    </div>
  </section>
</template>

<script>
import { EventBus } from '@/services/bus'
import AuthService from '@/services/authService'
export default {
  data () {
    return {
      isLoggedIn: null
    }
  },
  created: function () {
    this.isLoggedIn = AuthService.isLoggedIn()
    let vm = this
    EventBus.$on('isLoggedIn', function (isLoggedIn) {
      vm.isLoggedIn = isLoggedIn
    })
  }
}
</script>

<style scoped>
  .is-flex {
    justify-content: center;
  }
  div {
    background-color: cornflowerblue;
    padding: 20px;
    -webkit-border-radius: 7px;
    -moz-border-radius: 7px;
    border-radius: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoggedInDisplayer.vue